import "./_module.scss";

import React from "react";

import {Evenement, EvenementSkeleton} from "@/components/Evenement/Evenement";
import {Calendar} from "@/components/ui/calendar";
import {findEvenement} from "@/function/findEvenement";
import {evenement} from "@/types/evenement";

function ModuleCalendarEvent({
  evenements,
  onClick = () => {},
}: {
  evenements?: evenement[];
  onClick: (evenement: evenement[]) => void;
}): React.ReactElement {
  if (evenements !== undefined) {
    const dateEvent: Date[] | undefined = evenements?.map(event => {
      return new Date(event?.date);
    });

    const componentEvenement: React.ReactElement[] | undefined = evenements
      ?.map((event, index) => {
        return index < 3 ? (
          <Evenement evenement={event} key={`${index}-${event.libelle}`} />
        ) : undefined;
      })
      .filter((event): event is React.ReactElement => event !== undefined);
    const dayClick = (day: Date): void => {
      const eventFinded = findEvenement(day, evenements);
      onClick(eventFinded);
    };
    return (
      <div className="calendarEvent">
        <Calendar
          mode="multiple"
          className="rounded-md border calendarEvent-calendrier"
          selected={dateEvent}
          onDayClick={day => {
            dayClick(day);
          }}
        />
        <div className="calendarEvent-event">
          <h3>Prochainement</h3>
          {componentEvenement}
        </div>
      </div>
    );
  } else {
    return (
      <div className="calendarEvent">
        <Calendar className="rounded-md border calendarEvent-calendrier skeleton" />
        <div className="calendarEvent-event">
          <EvenementSkeleton />
          <EvenementSkeleton />
          <EvenementSkeleton />
        </div>
      </div>
    );
  }
}

export default ModuleCalendarEvent;
